'use es6';

import keyMirror from 'react-utils/keyMirror';
const PageActions = keyMirror({
  COMMUNICATOR_TRIGGER_LOCATION: null,
  COMMUNICATOR_LOCAL_STORAGE_CONTENT_DISCARDED: null,
  CALLING_APPEAL_SUBMITTED: null,
  NO_CALL_ACCESS_SCOPE: null
});
export { PageActions };